import { ActionIcon, Button, Tooltip } from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { copyToClipboard, useMedia } from '@mygpt/app/utils';
import { useMatch } from 'react-router-dom';

interface CopyButtonProps {
  text: string;
  copied: boolean;
  setCopied: (copied: boolean) => void;
  // 数字人模式下深色半透明背景，图标需要用浅色适配
  isDigitalHuman?: boolean;
}

export const CopyButton: React.FC<CopyButtonProps> = ({ text, copied, setCopied, isDigitalHuman }) => {
  const { t } = useTranslation();
  const { isMobile } = useMedia();
  const match = useMatch('/widget/:botId');
  const isWidgetPage = !!match;

  if (isMobile && !isWidgetPage) {
    return (
      <div className="items-center flex-1">
        <Button
          size="sm"
          variant="default"
          onClick={() => {
            const copied = copyToClipboard(text);
            setCopied(!!copied);
          }}
          className="border-[#E4E7EC] rounded-md h-10 px-2 w-full flex items-center justify-center gap-1"
        >
          {copied ? (
            <IconCheck size={18} color="teal" />
          ) : (
            <IconCopy size={20} stroke={1.8} className="hover:text-gray-600 text-gray-500" />
          )}
          <span className="ml-1 text-xs text-gray-600">{t('completions.copy')}</span>
        </Button>
      </div>
    );
  }

  return (
    <Tooltip label={t('copy')} withArrow>
      <ActionIcon
        variant={'subtle'}
        color={isDigitalHuman ? 'gray.0' : 'indigo'}
        onClick={() => {
          const copied = copyToClipboard(text);
          setCopied(!!copied);
        }}
      >
        {copied ? (
          <IconCheck color="teal" />
        ) : (
          <IconCopy
            size={22}
            stroke={1.7}
            className={isDigitalHuman ? 'text-white/80 hover:text-white' : 'hover:text-gray-600 text-gray-500'}
          />
        )}
      </ActionIcon>
    </Tooltip>
  );
};
